import axios, { InternalAxiosRequestConfig } from "axios";
import { notifyGlobalLoading } from "@/services/globalLoading";

const systemRoutes = new Set([
  "auth", "profile", "logout", "share", "help", "term_and_conditions",
  "tournaments", "initiatives", "challenges", "king-of-court",
  "penalty-championship", "meetpoints", "teams", "people", "market",
  "memberships", "participate", "services",
]);

export function getActiveLandingSlug(): string {
  if (typeof window === "undefined") return "";

  const fromQuery = new URLSearchParams(window.location.search).get("landing");
  if (fromQuery) return fromQuery;

  const firstPath = window.location.pathname.split("/").filter(Boolean)[0] || "";
  return firstPath && !systemRoutes.has(firstPath) ? firstPath : "";
}

export function withLandingContext(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const slug = getActiveLandingSlug();
  if (!slug) return config;

  config.headers.set("X-Landing-Slug", slug);
  return config;
}

let installed = false;

export function installLandingAxiosContext(): void {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use(withLandingContext);
  axios.interceptors.request.use((config) => {
    notifyGlobalLoading(1);
    return config;
  }, (error) => {
    notifyGlobalLoading(-1);
    return Promise.reject(error);
  });
  axios.interceptors.response.use((response) => {
    notifyGlobalLoading(-1);
    return response;
  }, (error) => {
    notifyGlobalLoading(-1);
    return Promise.reject(error);
  });
}
